import React, { useMemo } from 'react';
import ExportTranscriptModalContext from './ExportTranscriptModalContext';
import { ExportTranscriptModalContextType } from './types';

export type ExportTranscriptModalProviderProps =
  React.PropsWithChildren<ExportTranscriptModalContextType>;

const ExportTranscriptModalProvider: React.FC<
  ExportTranscriptModalProviderProps
> = ({ downloadFormatting, format, onDownloadFormattingChange, children }) => (
  <ExportTranscriptModalContext.Provider
    value={useMemo(
      () => ({ downloadFormatting, format, onDownloadFormattingChange }),
      [downloadFormatting, format, onDownloadFormattingChange],
    )}
  >
    {children}
  </ExportTranscriptModalContext.Provider>
);

export default ExportTranscriptModalProvider;
